import React from 'react';
import InfluencersHero from 'components/page-influencers/coming-soon-hero';
import InfluencerStickerSlider from 'components/templates-shared/influencers_sticker_slider';
import Meta from 'shared/meta';

function InfluencersComingSoonPage({ pageContext }) {
  const { influencer } = pageContext;
  const { country, firstName, lastName, username, followers } = influencer;

  function calculateTrueValue(total, rate) {
    let number = total * (rate);
    if (number.toFixed(0).toString().length > 6) {
      number = `${(number / 1000000).toFixed(1)}M`;
    } else if (number.toFixed(0).toString().length > 3) {
      number = `${(number / 1000).toFixed(1)}K`;
    } else {
      number = `${(number).toFixed(0)}`;
    }
    // return number.replace('.0', '');
    return number.toString().replace('.0', '');
  }

  const parsedFirstName = firstName && firstName.replace(firstName[0], firstName[0].toUpperCase());
  const parsedLastName = lastName && lastName.replace(lastName[0], lastName[0].toUpperCase());

  const description = `${parsedFirstName} ${parsedLastName} is an influencer located in${country?.name === 'United States' ? ' the' : ''} ${country ? country.name : 'United States'}. Has ${followers !== '' ? calculateTrueValue(followers, 1) : ''} followers.`;

  return (
    <main>
      <Meta title={`${parsedFirstName} ${parsedLastName} @${username} | Furlough Ф Influencer`} description={description} canonical={`https://furlough.com/influencer/${username.replace('@', '')}`} />
      <InfluencersHero {...{ ...influencer }} />
      <InfluencerStickerSlider />
    </main>
  );
}

export default InfluencersComingSoonPage;
